module.exports = __webpack_public_path__ + "img/ibis-lisboa-centro-saldanha.1cbf9366.jpg";